import React from 'react';

import { Select, type SelectProps } from '@/components/ui/select';
import { cn } from '@/lib/utils';

export const DetailsSelect = React.forwardRef<HTMLButtonElement, SelectProps>(
  ({ label, className, ...props }, ref) => {
    return (
      <div className={cn('mb-[5px] grid grid-cols-2 gap-2 overflow-hidden')}>
        <p className="min-w-[20%] grow-0 text-base text-text-secondary">{label}:</p>
        <Select
          ref={ref}
          size="xs"
          className={cn('!h-6 border-none text-sm font-medium [&>button]:pl-[10px]', className)}
          {...props}
        />
      </div>
    );
  }
);
